<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
@media (max-width: 768px) {
  .el-message-box {
    width: 335px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue